import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';


@Component({
  selector: 'app-monthly-actual',
  templateUrl: './monthly-actual.component.html',
  styleUrls: ['./monthly-actual.component.scss']
})
export class MonthlyActualComponent implements OnInit {
  reportSection: boolean;

  constructor(private _Activatedroute: ActivatedRoute) {
  }

  ngOnInit() {
    this._Activatedroute.queryParams.subscribe(params => {
      this.reportSection = params['reportSection'];
    });
  }

}
